import {AxiosInstance} from "axios";
import AttachmentUploadUrl from "../model/attachment/AttachmentUploadUrl";

export default class AttachmentApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	static getAttachmentDownloadUrl(attachmentId: string) {
		return `/api/web/attachments/${attachmentId}`;
	}

	/**
	 * Create upload url
	 * @param {string} name
	 * @returns {Promise<AttachmentUploadUrl>}
	 */
	private createUploadUrl(name: string): Promise<AttachmentUploadUrl> {
		const url = `/api/web/attachments`;
		return this.axiosInstance.post(url, {name}).then(resp => AttachmentUploadUrl.fromJson(resp.data))
	}

	/**
	 * Upload file
	 * @param {File} file
	 * @returns {AxiosPromise<string>}
	 */
	uploadFile(file: File): Promise<string> {
		return this.createUploadUrl(file.name).then(attUploadUrl => {
			const config = {
				headers: {
					'Content-Type': file.type
				}
			};
			return this.axiosInstance.put(attUploadUrl.uploadUrl, file, config).then(() => {
				return attUploadUrl.id;
			})
		});
	}

	/**
	 * Download file as base64 buffer.
	 * @param {string} attachmentId
	 * @returns {Promise<Buffer>}
	 */
	downloadFile(attachmentId: string) {
		return this.axiosInstance.get(AttachmentApi.getAttachmentDownloadUrl(attachmentId), {responseType: 'arraybuffer'})
			.then(response => new Buffer(response.data, 'binary'));
	}
}

